'use client'

import { GoogleMap, LoadScript, MarkerF } from "@react-google-maps/api"

const containerStyle = {
    width: "100%",
    height: "100%"
}

const position = {
    lat: 34.551959628325804, 
    lng: 135.50550576844788
}

const Map = () => {
    const api_key = process.env.GOOGLE_MAPS_API_KEY
    return(
        <LoadScript googleMapsApiKey="AIzaSyAzMPskEk5JH4_lz2JmDiC8dy9E-euG5dk">
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={position}
                zoom={18}
            >
                <MarkerF position={position} />
            </GoogleMap>
        </LoadScript>
    )
}

export default Map